module.exports = __webpack_public_path__ + "img/90.7a5e06c0.jpg";